export default __webpack_public_path__ + "static/media/screen_livechat_10.0390f5c6.png";